import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import { Container, Header } from 'semantic-ui-react';
const Section = props => {
    return (
        <Element name={props.name} className={`section ${props.mobileShow ? "mobileShow" : "mobileHide"} ${props.name}`}>
            <Container>
                <Header as="h1" content={props.title} className={props.color} />
                {props.children}            
            </Container>
        </Element>
    );
};

Section.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    children: PropTypes.node,
    mobileShow: PropTypes.bool,
};

export default Section;